<template>
  <div class="extra" id="extra">
    <div class="wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Jovana i Luka u Pinkovim Zvezdama</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="top-video-holder" data-aos="fade-right">
              <div class="youtube" data-embed="MU3qW-oLjsg">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Bela ciganka</h4>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="top-video-holder" data-aos="fade-left">
              <div class="youtube" data-embed="ZJ4Gs1ZLWRk">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Okuj me care</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    mounted() {
      var youtube = document.querySelectorAll( ".youtube" );
      for (var i = 0; i < youtube.length; i++) {
        // thumbnail image source
        let source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/hqdefault.jpg";

        // Load the image asynchronously
        var image = new Image();
        image.src = source;
        image.addEventListener( "load", function() {
          youtube[ i ].appendChild( image );
        }( i ) );


        youtube[i].addEventListener( "click", function() {

          var iframe = document.createElement( "iframe" );

          iframe.setAttribute( "frameborder", "0" );
          iframe.setAttribute( "allowfullscreen", "" );
          iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

          this.innerHTML = "";
          this.appendChild( iframe );
        } );
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ExtraSection.vue